import AmountTextBox from "@/app/components/common/actions/inputs-b/AmountTextBox";
import { ICON_BASE_PATH } from "@/app/utils/config";
import { useEffect, useState } from "react";
import type { NumericTextBoxChangeEvent } from "@progress/kendo-react-inputs";

export interface ThresholdValue {
  type: "lower" | "upper";
  amount: string;
  currencyCode: string;
}

interface ThresholdProps {
  isOpen: boolean;
  onClose: () => void;
  type: "lower" | "upper";
  initialAmount?: string;
  initialCurrencyCode?: string;
  onSave: (value: ThresholdValue) => void;
}

const Threshold = ({
  isOpen,
  onClose,
  type,
  initialAmount = "",
  initialCurrencyCode = "AED",
  onSave,
}: ThresholdProps) => {
  const [amount, setAmount] = useState(initialAmount);
  const [currencyCode, setCurrencyCode] = useState(initialCurrencyCode);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (isOpen) {
      setAmount(initialAmount);
      setCurrencyCode(initialCurrencyCode);
      setErrorMessage("");
    }
  }, [isOpen, type, initialAmount, initialCurrencyCode]);

  if (!isOpen) return null;

  const handleSave = () => {
    if (!amount || Number(amount) <= 0) {
      setErrorMessage("Please enter a valid threshold amount.");
      return;
    }
    onSave({ type, amount, currencyCode });
    onClose();
  };

  const handleAmountChange = (event: NumericTextBoxChangeEvent) => {
    setAmount(
      event.target.value === null || event.target.value === undefined
        ? ""
        : String(event.target.value),
    );
  };

  return (
    <div className="threshold-overlay">
      <div className="threshold-modal">
        <div className="threshold-header">
          <h2>
            <img src={`${ICON_BASE_PATH}settinglogo.svg`} alt={"setting"} />
            Configure {type === "lower" ? "Lower" : "Upper"} Balance Threshold
          </h2>

          <p>
            You will receive notifications when the available balance
            {type === "lower"
              ? " drops below the configured threshold."
              : " exceeds the configured threshold."}
          </p>
        </div>

        <div className="threshold-body">
          <label>
            Threshold Amount <span>*</span>
          </label>
          <div className="mt-3">
            <AmountTextBox
              value={amount}
              onChange={handleAmountChange}
              onChangeCurrency={(code: string) => setCurrencyCode(code)}
              initialCurrencyCode={initialCurrencyCode}
              required
            />
          </div>
          {errorMessage && <p className="threshold-error">{errorMessage}</p>}
        </div>

        <div className="threshold-footer">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>

          <button className="save-btn" onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default Threshold;
